import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGivebutterRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#232323",
			d: "M9.9 4.3h12.6a6 6 0 0 1 2.7 1.3 6 6 0 0 1 2.2 3.7v13.5q-.4 1.3-1.2 2.5a6 6 0 0 1-4.2 2.2H11.4l-2.2-.1a6 6 0 0 1-4.8-5l-.1-2.8V9q.3-1.5 1.3-2.6 1.7-2 4.3-2.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffc000",
			d: "M10.4 6.1h1q.4 0 .7.2c1 .7 0 1.9.8 2.6q.7.8 1.6 0c.6-.6-.1-1.8.6-2.5l.8-.3q1.3.3 1 1.6V9l.1 1q0 .4.3.6.2.3.8.3.9 0 1-.9l.1-1V7.3q0-.4.3-.9.8-.4 1.7-.3c2.6 0 4.5 1.6 4.5 4.3v9.3c0 1.8.1 3.3-1.2 4.7a4 4 0 0 1-2.9 1.3H10C8 25.6 6.4 24 6 22V10a4 4 0 0 1 4.4-4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#d99600",
			d: "M21.2 6.1c2.6 0 4.5 1.6 4.5 4.3v9.3c0 1.8.1 3.3-1.2 4.7a4 4 0 0 1-2.9 1.3h-.5.3l.4-.2c1.3-.5 2.2-2 2.3-3.4V10l-.3-1.4q-.5-1.5-1.9-2.3l-.6-.2zM10.3 25.7H10C8 25.6 6.4 24 6 22V10a4 4 0 0 1 4.4-4 4 4 0 0 0-2.7 3.5V22l.2 1q.5 1.9 2.3 2.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#232323",
			d: "m19.3 18.7.1-.004q.7 0 .7.6c-.3 3.5-4.3 5.4-7 2.8-.5-.5-1.5-2-1.2-2.8q.2-.4.6-.3.9.1 1.6.4 1.8.5 3.6 0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fefefe",
			d: "M14.2 21.3h3.2c.9 0 .1.6-.2.9l-.4.2q-1 .3-1.8 0c-.3-.1-1.5-1-.8-1.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#232323",
			d: "M11.2 12h.7q.6.3.9.9c.7 1.2-.1 3.5-1.8 2.9q-1.4-.9-1-2.4.4.4 1.1.3l.6-.6c.2-.6-.3-.7-.5-1m8.9 0h.7q.6.3.9 1l.1 1.2-.2.6q-.5 1.3-1.9.9c-.9-.5-1-1.6-1-2.4l.8.4c1 0 1.3-1 .6-1.7"
		})
	]
});
export default SvgGivebutterRegularIcon;
